import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';
import QuoteForm from './components/QuoteForm';
import ConsultationProcess from './components/ConsultationProcess';
import TrustSignals from './components/TrustSignals';
import EmergencyContact from './components/EmergencyContact';
import SchedulingIntegration from './components/SchedulingIntegration';
import logo from '../../../public/assets/images/fibrelogo.png';

const GetQuoteConsultation = () => {
  const [activeTab, setActiveTab] = useState('quote');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [assessmentData, setAssessmentData] = useState(null);
  const location = useLocation();
    const [contactForm, setContactForm] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const validate = () => {
    let newErrors = {};
    if (!contactForm.name.trim()) newErrors.name = "Name is required";
    if (!contactForm.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(contactForm.email)) {
      newErrors.email = "Enter a valid email";
    }
    if (!contactForm.message.trim())
      newErrors.message = "Message cannot be empty";
    return newErrors;
  };

  const handleChange = (e) => {
    setContactForm({
      ...contactForm,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      console.log("Contact Form Data:", contactForm);
      setSubmitted(true);
      // Here you can call API to send form data to backend
    }
  };

  // Check for assessment data from previous page
  useEffect(() => {
    if (location?.state?.assessmentData) {
      setAssessmentData(location?.state?.assessmentData);
    }
  }, [location?.state]);

  const handleFormSubmit = (formData) => {
    console.log('Form submitted:', formData);
    setFormSubmitted(true);
    // Here you would typically send the data to your backend
  };

//   const handleFormSubmit = async (e) => {debugger;
//   e.preventDefault();

//   const formType = activeTab === "quote" ? "Get Quote" : "Schedule Consultation";

//   const data = new FormData();
// debugger;
//   if (formType === "Get Quote") {
//     data.append("formType", "Get Quote");
//     data.append("projectType", formData.projectType);
//     data.append("urgency", formData.urgency);
//     data.append("company", formData.companyName);
//     data.append("name", formData.contactName);
//     data.append("email", formData.email);
//     data.append("phone", formData.phone);
//     data.append("address", formData.address);
//     data.append("city", formData.city);
//     data.append("state", formData.state);
//     data.append("zipCode", formData.zipCode);
//     data.append("currentInfrastructure", formData.currentInfrastructure);
//     data.append("buildingSize", formData.buildingSize);
//     data.append("employeeCount", formData.employeeCount);
//     data.append("specificRequirements", formData.specificRequirements);
//   }

//   if (formType === "Schedule Consultation") {
//     data.append("formType", "Schedule Consultation");
//     data.append("name", contactForm.name);
//     data.append("email", contactForm.email);
//     data.append("phone", contactForm.phone);
//     data.append("date", scheduleData.date);
//     data.append("time", scheduleData.time);
//     data.append("team", scheduleData.team);
//     data.append("message", contactForm.message);
//   }

//   try {
//     const response = await fetch("/send-mail.php", {
//       method: "POST",
//       body: data,
//     });

//     const result = await response.text();
//     if (result === "success") {
//       setFormSubmitted(true);
//     } else {
//       alert("Failed to send email. Please try again.");
//     }
//   } catch (err) {
//     console.error("Error:", err);
//     alert("Something went wrong.");
//   }
// };


  const tabs = [
    { id: 'quote', label: 'Get Quote', icon: 'FileText' },
    { id: 'schedule', label: 'Schedule Consultation', icon: 'Calendar' },
    { id: 'process', label: 'Our Process', icon: 'Info' }
  ];

  const benefits = [
    {
      title: "Expert Assessment",
      description: "Certified technicians evaluate your current infrastructure and identify optimization opportunities",
      icon: "Search"
    },
    {
      title: "Custom Solutions",
      description: "Tailored recommendations based on your specific business needs and growth plans",
      icon: "Settings"
    },
    {
      title: "Transparent Pricing",
      description: "Clear, detailed quotes with no hidden fees or surprise costs",
      icon: "DollarSign"
    },
    {
      title: "Minimal Disruption",
      description: "Strategic implementation planning to minimize business interruption",
      icon: "Shield"
    }
  ];

  const stats = [
    { label: "Average Response Time", value: "2 Hours", icon: "Clock" },
    { label: "Consultation Satisfaction", value: "98%", icon: "ThumbsUp" },
    { label: "Projects Completed", value: "500+", icon: "CheckCircle" },
    { label: "Emergency Response", value: "24/7", icon: "Phone" }
  ];

  if (formSubmitted) {
    return (
      <div className="min-h-screen bg-background">
        <Header />
        <main className="pt-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
            <div className="text-center">
              <div className="w-16 h-16 bg-accent rounded-full flex items-center justify-center mx-auto mb-6">
                <Icon name="CheckCircle" size={32} className="text-white" />
              </div>
              <h1 className="text-3xl font-bold text-text-primary mb-4">
                Thank You for Your Request!
              </h1>
              <p className="text-lg text-text-secondary mb-8 max-w-2xl mx-auto">
                We've received your consultation request and will contact you within 2 business hours. 
                Our team is already reviewing your requirements to provide the best possible solution.
              </p>
              
              <div className="bg-white rounded-lg shadow-brand-moderate p-6 mb-8">
                <h2 className="text-xl font-semibold text-text-primary mb-4">What Happens Next?</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="text-center">
                    <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center mx-auto mb-3">
                      <Icon name="Phone" size={20} className="text-white" />
                    </div>
                    <h3 className="font-medium text-text-primary mb-2">Initial Contact</h3>
                    <p className="text-sm text-text-secondary">Within 2 hours</p>
                  </div>
                  <div className="text-center">
                    <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center mx-auto mb-3">
                      <Icon name="Calendar" size={20} className="text-white" />
                    </div>
                    <h3 className="font-medium text-text-primary mb-2">Schedule Assessment</h3>
                    <p className="text-sm text-text-secondary">Within 24 hours</p>
                  </div>
                  <div className="text-center">
                    <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center mx-auto mb-3">
                      <Icon name="FileText" size={20} className="text-white" />
                    </div>
                    <h3 className="font-medium text-text-primary mb-2">Receive Proposal</h3>
                    <p className="text-sm text-text-secondary">Within 2-3 days</p>
                  </div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button
                  variant="outline"
                  size="lg"
                  iconName="Phone"
                  iconPosition="left"
                >
                  Call Us: (555) 123-FIBER
                </Button>
                <Button
                  variant="default"
                  size="lg"
                  iconName="Home"
                  iconPosition="left"
                  onClick={() => window.location.href = '/homepage'}
                  className="cta-primary"
                >
                  Return to Homepage
                </Button>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-16">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-primary/5 to-accent/5 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h1 className="text-4xl md:text-5xl font-bold text-text-primary mb-6">
                Get Your Custom Fiber Solution
              </h1>
              <p className="text-xl text-text-secondary max-w-3xl mx-auto mb-8">
                Transform your business connectivity with expert consultation and transparent pricing. 
                Our certified team provides comprehensive assessments and custom solutions tailored to your needs.
              </p>
              
              {assessmentData && (
                <div className="bg-accent/10 border border-accent/20 rounded-lg p-4 max-w-2xl mx-auto mb-8">
                  <div className="flex items-center justify-center space-x-2">
                    <Icon name="CheckCircle" size={20} className="text-accent" />
                    <span className="font-medium text-accent">
                      Assessment data available - we'll use this to provide more accurate recommendations
                    </span>
                  </div>
                </div>
              )}
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
              {stats?.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mx-auto mb-3 shadow-brand-subtle">
                    <Icon name={stat?.icon} size={20} className="text-primary" />
                  </div>
                  <div className="text-2xl font-bold text-text-primary mb-1">{stat?.value}</div>
                  <div className="text-sm text-text-secondary">{stat?.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Emergency Contact */}
        <section className="py-8">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <EmergencyContact />
          </div>
        </section>

        {/* Main Content */}
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {/* Main Content Area */}
              <div className="lg:col-span-2">
                {/* Tab Navigation */}
                <div className="flex flex-wrap gap-2 mb-8 p-1 bg-muted rounded-lg">
                  {tabs?.map((tab) => (
                    <button
                      key={tab?.id}
                      onClick={() => setActiveTab(tab?.id)}
                      className={`flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
                        activeTab === tab?.id
                          ? 'bg-white text-primary shadow-brand-subtle'
                          : 'text-text-secondary hover:text-text-primary hover:bg-white/50'
                      }`}
                    >
                      <Icon name={tab?.icon} size={16} />
                      <span>{tab?.label}</span>
                    </button>
                  ))}
                </div>

                {/* Tab Content */}
                <div className="space-y-8">
                  {activeTab === 'quote' && (
                    <QuoteForm 
                      onSubmit={handleFormSubmit}
                      assessmentData={assessmentData}
                    />
                  )}
                  
                  {activeTab === 'schedule' && (
                    <SchedulingIntegration />
                  )}
                  
                  {activeTab === 'process' && (
                    <ConsultationProcess />
                  )}
                </div>
              </div>

              {/* Sidebar */}
              <div className="lg:col-span-1">
                <TrustSignals />
              </div>
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="py-16 bg-muted/30">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-text-primary mb-4">
                Why Choose Xtreem Fibre Solutions?
              </h2>
              <p className="text-lg text-text-secondary max-w-2xl mx-auto">
                Our comprehensive approach ensures you get the right solution for your business needs
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {benefits?.map((benefit, index) => (
                <div key={index} className="bg-white rounded-lg shadow-brand-moderate p-6 text-center hover:shadow-brand-strong transition-shadow duration-200">
                  <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon name={benefit?.icon} size={24} className="text-primary" />
                  </div>
                  <h3 className="text-lg font-semibold text-text-primary mb-3">
                    {benefit?.title}
                  </h3>
                  <p className="text-text-secondary">
                    {benefit?.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

            
            
      </main>
      {/* Footer */}
      <footer className="bg-slate-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <div className="relative">
                  <img
                                                  src={logo}
                                                      alt="Xtreem Fibre Solutions"
                                                      width={80}
                                                      height={80}
                                                      className="h-16 w-auto brightness-0 invert transition-transform duration-300 group-hover:scale-105"/>
                </div>
                <div>
                  <h3 className="text-lg font-bold">Xtreem Fibre Solutions</h3>
                  <p className="text-sm opacity-75">
                    Infrastructure Transformation
                  </p>
                </div>
              </div>
              <p className="text-sm opacity-75 mb-4">
                Connecting businesses to their digital future through expert
                fiber optic solutions.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Emergency Support</h4>
              <div className="space-y-2 text-sm">
                <div className="flex items-center space-x-2">
                  <Icon name="Phone" size={14} />
                  <span>1-800-FIBER-911</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="Clock" size={14} />
                  <span>24/7/365 Available</span>
                </div>
              </div>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Regional Offices</h4>
              <div className="space-y-2 text-sm opacity-75">
                <div>London HQ: 01483 343 064</div>
                {/* <div>Manchester: +44 161 850 0022</div>
                <div>Birmingham: +44 121 450 0033</div>
                <div>Glasgow: +44 141 330 0044</div>
                <div>Brighton: +44 1273 550 0055</div> */}
              </div>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Certifications</h4>
              <div className="space-y-2 text-sm opacity-75">
                <div>BICSI Certified</div>
                <div>NECA Contractor</div>
                <div>FOA Approved</div>
                <div>OSHA Compliant</div>
              </div>
            </div>
          </div>

          <div className="border-t border-slate-700 mt-8 pt-8 text-center text-sm opacity-75">
            <p>
              &copy; {new Date()?.getFullYear()} Xtreem Fibre Solutions. All
              rights reserved. | Licensed & Insured in All Service Areas
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default GetQuoteConsultation;